export default __webpack_public_path__ + "static/media/whatsapp-logo.107e310b.webp";